import React,{ Component } from 'react';
import ProjectcopyList from '../projectscopy/ProjectcopyList'
import {connect} from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import Footer from './footer';

class Members extends Component{
    render(){
        const { projectcopys } = this.props;
        return(
            <div>
        <div class="font_meie_script" style={{textAlign:'center',color:'white'}}>
            <h2>
                Connect with our super cool team who take upon challenges<br/> and strive for perfection in whatever they do.
            </h2>
        </div>
            <div className="dashboard container">
                <div className="row">
                   <div className="col-sm-4"></div>
                    <div className="col-sm-4">
                        <ProjectcopyList projectcopys={projectcopys}/>
                    </div>
                    <div className="col-sm-4"></div>
                     </div>
                </div>
                <Footer />
                </div>
            
        )
    }
}
const mapStateToProps = (state)=>{
    console.log(state);
    return {
        projectcopys: state.firestore.ordered.projectcopys
    }
}
export default compose(
    connect(mapStateToProps),
    firestoreConnect([
        {collection:'projectcopys'}
    ])
)(Members)